const hexColorRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

/** A 6-digit hex color is three channels, two characters each. */
const HEX_CHANNEL_COUNT = 3;
const HEX_CHANNEL_WIDTH = 2;
const HEX_GREEN_OFFSET = HEX_CHANNEL_WIDTH;
const HEX_BLUE_OFFSET = HEX_CHANNEL_WIDTH * 2;
const HEX_END_OFFSET = HEX_CHANNEL_WIDTH * HEX_CHANNEL_COUNT;

export function hexToRgb(hex: string): [number, number, number] {
  if (!hexColorRegex.test(hex)) {
    return [0, 0, 0];
  }

  const formatted = hex.replace("#", "");

  return [
    formatted.slice(0, HEX_CHANNEL_WIDTH),
    formatted.slice(HEX_GREEN_OFFSET, HEX_BLUE_OFFSET),
    formatted.slice(HEX_BLUE_OFFSET, HEX_END_OFFSET),
  ].map((part) => parseInt(part, 16)) as [number, number, number];
}

function calcColorDistance(
  hexColorLeft: string,
  hexColorRight: string
): number {
  const [redLeft, greenLeft, blueLeft] = hexToRgb(hexColorLeft);
  const [redRight, greenRight, blueRight] = hexToRgb(hexColorRight);

  return Math.sqrt(
    Math.pow(redRight - redLeft, 2) +
      Math.pow(greenRight - greenLeft, 2) +
      Math.pow(blueRight - blueLeft, 2)
  );
}

export function getClosestColor(customColor: string, list: string[]) {
  const mapped: [string, number][] = list.map((hex) => [
    hex,
    calcColorDistance(hex, customColor),
  ]);

  return mapped.reduce<{ color: string; distance: number }>(
    (acc, [hex, distance]) =>
      distance < acc.distance ? { color: hex, distance } : acc,
    {
      color: "",
      distance: Infinity,
    }
  );
}
